module.exports = __webpack_public_path__ + "static/media/1.e7326d6a.JPG";